import { useGetStrings } from "@app/store/service/cmsService"
import { faCheck, faCircle, faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./PasswordValidation.css"

export default function PasswordValidation({ password = "" }) {
	const {
		data: {
			passwordValidationHeadline,
			passwordRequirementMinLength,
			passwordRequirementUpperLower,
			passwordRequirementSpecialChar,
			passwordRequirementNumber,
		},
	} = useGetStrings(undefined, { defaultData: {} })

	const hasMinLength = password.length >= 8
	const hasUppercase = /[A-Z]/.test(password)
	const hasLowercase = /[a-z]/.test(password)
	const hasNumber = /[0-9]/.test(password)
	const hasSpecialChar = /[^A-Za-z0-9]/.test(password)

	const getClass = condition => {
		if (!password) return "neutral"
		return condition ? "valid" : "invalid"
	}

	const getIcon = state => {
		switch (state) {
			case "valid":
				return faCheck
			case "invalid":
				return faXmark
			default:
				return faCircle
		}
	}

	const getPasswordStrength = () => {
		if (!password) return ""

		const baseRequirements = hasUppercase && hasLowercase && hasNumber && hasSpecialChar

		if (baseRequirements && password.length >= 12) return "strong"
		else if (baseRequirements && password.length >= 10) return "medium"
		else return "weak"
	}

	return (
		<>
			<div className="passwordStrength passwordStrength__outter">
				<div className={`passwordStrength__inner ${getPasswordStrength()}`} />
			</div>

			<div className="passwordValidation flex flex-column f6 padding-sm-4">
				<div className="passwordValidationHeadline">{passwordValidationHeadline}</div>

				<div className={`flex flex-row validationCondition ${getClass(hasMinLength)}`}>
					<div className="circle flex flex-row flex-center">
						<FontAwesomeIcon icon={getIcon(getClass(hasMinLength))} size="xs" />
					</div>
					<span>{passwordRequirementMinLength}</span>
				</div>

				<div className={`flex flex-row validationCondition ${getClass(hasUppercase && hasLowercase)}`}>
					<div className="circle flex flex-row flex-center">
						<FontAwesomeIcon icon={getIcon(getClass(hasUppercase && hasLowercase))} size="xs" />
					</div>
					<span>{passwordRequirementUpperLower}</span>
				</div>

				<div className={`flex flex-row validationCondition ${getClass(hasSpecialChar)}`}>
					<div className="circle flex flex-row flex-center">
						<FontAwesomeIcon icon={getIcon(getClass(hasSpecialChar))} size="xs" />
					</div>
					<span>{passwordRequirementSpecialChar}</span>
				</div>

				<div className={`flex flex-row validationCondition ${getClass(hasNumber)}`}>
					<div className="circle flex flex-row flex-center">
						<FontAwesomeIcon icon={getIcon(getClass(hasNumber))} size="xs" />
					</div>
					<span>{passwordRequirementNumber}</span>
				</div>
			</div>
		</>
	)
}
